import React from 'react'

interface OnboardingProgressProps {
  /** 1-based index of the current step. */
  current: number
  /** Total number of steps. */
  total: number
}

/**
 * #693: segmented progress bar shared across the onboarding steps, matching the
 * payhelm.com/onboard wizard mockup. Filled segments = completed/current.
 */
const OnboardingProgress: React.FC<OnboardingProgressProps> = ({ current, total }) => (
  <div className="tw-flex tw-gap-2" role="progressbar" aria-valuenow={current} aria-valuemin={1} aria-valuemax={total}>
    {Array.from({ length: total }).map((_, i) => (
      <div
        key={i}
        className={`tw-h-1.5 tw-flex-1 tw-rounded-full tw-transition-colors ${
          i < current ? 'tw-bg-indigo-500' : 'tw-bg-slate-200'
        }`}
      />
    ))}
  </div>
)

export default OnboardingProgress
